import React from "react";
import PropTypes from "prop-types";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import CustomInput from "../CustomInput/CustomInput";

function TextFilter(props) {
  const { classes } = props;

  const { extraFilterKeyValuePairs } = props;

  return (
    <CustomInput
      formControlProps={{
        style: { paddingTop: "0" },
        fullWidth: true,
      }}
      inputProps={{
        type: "text",
        name: "id",
        placeholder: props.placeholder,
        disabled: props.disabled ?? false,
        onChange: (e) => {
          let value = props.onParseValue(e.target.value);
          if (value) {
            props.setFilter(props.fieldKey, {
              field: props.field ?? props.fieldKey,
              operator: props.operator,
              value: value,
              ...(props.extraFilterKeyValuePairs ?? {}),
            });
          } else {
            props.setFilter(props.fieldKey, null);
          }
        },
        value: props[props.fieldKey]?.value ?? "",
      }}
    />
  );
}

TextFilter.propTypes = {
  placeholder: PropTypes.string,
  fieldKey: PropTypes.string.isRequired,
  field: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  operator: PropTypes.string,
  onParseValue: PropTypes.func,
  inputProps: PropTypes.object,
};

TextFilter.defaultProps = {
  operator: "=",
  onParseValue: (v) => v,
};

const mapStateToProps = (state, props) => ({
  [props.fieldKey]: state.filtersV2[props.fieldKey],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TextFilter, productenStyle));
